(ns basic-components.html-table.cell
  (:require
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [common.entity :as entity]
   [frontend.utils :as fu]
   [common.currencies :as currencies]
   [common.localization :as loc]
   [common.util :as cu]
   [basic-components.tooltip :as tooltip]
   [basic-components.inputs.footprint :refer [viewer]]
   [common.schema.registry :as registry]))

(defn show-tooltip?
  [value trunc-limit]
  (and (not (nil? trunc-limit))
       (> (count value) trunc-limit)))

;; The dispatch should be changed from data-type to grid-type (or even a new html-table-component specific type)
;; to allow different behavior for different fields even if the data-type happens to be the same.
(defmulti cell
  (fn [{:keys [column-meta]}]
    (:column/data-type column-meta)))

(defmethod cell :default
  [{:keys [cell-value]}]
  [:span
   cell-value])

(defmethod cell :data.type/boolean
  [{:keys [cell-value]}]
  [:span
   {:class "text-xl"}
   (if cell-value
     [:i.fal.fa-check-circle]
     [:i.fal.fa-times-circle])])

(defmethod cell :data.type/currency-symbol
  [{:keys [cell-value]}]
  (currencies/get-label cell-value))

(defmethod cell :data.type/currency-value
  [{:keys [cell-value]}]
  (some-> cell-value
          fu/bigdec->float))

(defmethod cell :data.type/email
  [{:keys [cell-value row-data]}]
  (let [trunc-limit (:trunc-limit row-data)
        cell-value (str cell-value)
        truncated-value (cu/truncate trunc-limit cell-value)]
    (if (show-tooltip? cell-value trunc-limit)
      [tooltip/view cell-value
       [:span truncated-value]]
      cell-value)))

(defmethod cell :data.type/text-url
  [{:keys [cell-value]}]
  (str cell-value))

(defmethod cell :data.type/text
  [{:keys [cell-value row-data]}]
  (let [trunc-limit (:trunc-limit row-data)
        truncated-value (cu/truncate trunc-limit cell-value)]
    (if (show-tooltip? cell-value trunc-limit)
      [tooltip/view cell-value
       [:span truncated-value]]
      cell-value)))

(defmethod cell :data.type/text-simple
  [{:keys [cell-value row-data]}]
  (let [trunc-limit (:trunc-limit row-data)
        truncated-value (cu/truncate trunc-limit cell-value)]
    (if (show-tooltip? cell-value trunc-limit)
      [tooltip/view cell-value [:span truncated-value]]
      [:span cell-value])))

(defmethod cell :data.type/id
  [{:keys [cell-value row-data]}]
  (let [entity (get @session/entities cell-value)
        entity-type (:entity/type row-data)]
    (when-not (= entity-type :entity.type/entity-association)
      [:a
       {:href "#"
        :on-click #(routing/open-entity cell-value)}
       (or (entity/resolve-entity-name entity session/get-entity session/reverse-lookup)
           (str cell-value))])))

(defmethod cell :data.type/integer
  [{:keys [cell-value]}]
  (str cell-value))

(defmethod cell :data.type/keyword-multi
  [{:keys [column-meta tenant-schema cell-value field-schema]}]
  (let [data-type (:column/data-type column-meta)
        default-field-schema (registry/get-field-schema tenant-schema (:column/key column-meta))
        field-schema (if field-schema
                       field-schema
                       default-field-schema)
        options (:options field-schema)]
    (if (and (or (= data-type :data.type/keyword)
                 (= data-type :data.type/keyword-multi))
             (seq options))
      (some->> cell-value
               (fu/display-option-values options))
      (some->> cell-value
               (fu/display-keywords)))))

(defmethod cell :data.type/keyword
  [{:keys [cell-value tenant-schema field-schema column-meta]}]
  (let [default-field-schema (registry/get-field-schema tenant-schema (:column/key column-meta))
        field-schema (if field-schema
                       field-schema
                       default-field-schema)
        options (:options field-schema)]
    (if (seq options)
      (some->> cell-value
               (fu/find-option-label options))
      (loc/field-name cell-value (registry/get-field-schema tenant-schema cell-value)))))

(defmethod cell :data.type/long
  [{:keys [cell-value]}]
  (str cell-value))

(defmethod cell :data.type/number
  [{:keys [cell-value]}]
  (some-> cell-value
          (fu/round 2)
          (fu/format-with-separators 2 false 2)))

(defmethod cell :data.type/percentage
  [{:keys [cell-value]}]
  (str (some-> cell-value
               (* 100)
               (fu/round 2)
               (fu/format-with-separators 2 false 2))
       (when cell-value "%")))

(defmethod cell :data.type/multiplier
  [{:keys [cell-value]}]
  (str (some-> cell-value
               (fu/round 3)
               (fu/format-with-separators 3 false 3))
       (when cell-value "x")))

(defmethod cell :data.type/ref-multi
  [{:keys [cell-value tenant-schema field-schema column-meta]}]
  (let [default-field-schema (registry/get-field-schema tenant-schema (:column/key column-meta))
        field-schema (if field-schema
                       field-schema
                       default-field-schema)
        named-value? (-> field-schema
                         :named-value-attribute)]
    (cond named-value?
          (some->> cell-value
                   fu/display-named-value-entities)
          :else
          (or (some->> cell-value
                       fu/display-entities)
              (str cell-value)))))

(defmethod cell :data.type/ref-single
  [{:keys [cell-value]}]
  (some->> cell-value
           fu/display-entity))

(defmethod cell :data.type/text-multiline
  [{:keys [cell-value row-data]}]
  (let [trunc-limit (:trunc-limit row-data)
        truncated-value (cu/truncate trunc-limit cell-value)]
    (if (show-tooltip? cell-value trunc-limit)
      [tooltip/view cell-value [:span (str truncated-value "...")]]
      [:span cell-value])))

(defmethod cell :data.type/text-richtext
  [{:keys [cell-value]}]
  [viewer
   {:editor/type :editor.type/wysiwyg
    :value       cell-value}])

(defmethod cell :data.type/datetime
  [{:keys [cell-value]}]
  (fu/display-datetime-timestamp cell-value))

(defmethod cell :data.type/date
  [{:keys [cell-value]}]
  (fu/display-timestamp cell-value))
